<mat-toolbar class="flex space-x-1">
  <span class="text-2xl">{{label()}}</span>
</mat-toolbar>
<mat-tab-group #myTabGroup>
  <mat-tab label="主要查詢">
    <div style="width:800px;">
      <table mat-table [dataSource]="paramList" class="mat-elevation-z8" >
        <ng-container matColumnDef="fieldName">
          <th mat-header-cell *matHeaderCellDef  style="width: 33%;"> 欄位名稱 </th>
          <td mat-cell *matCellDef="let element"> {{element.fieldName}} </td>
        </ng-container>
        <ng-container matColumnDef="compare">
          <th mat-header-cell *matHeaderCellDef style="width: 33%;"> 運算 </th>
          <td mat-cell *matCellDef="let element">
            <app-jkcombobox [items]="compareList" [(value)]="element.compare">
            </app-jkcombobox>
            <!-- <app-jkedit [(value)]="element.compare">
            </app-jkedit> -->
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef style="width: 34%;"> 運算資料 </th>
          <td mat-cell *matCellDef="let element">
            <!-- <input [(value)]="element.value">  -->
            <!-- <app-jkedit [displayLabel]="false" [(value)]="element.value" (valueChange)="elementValueChange($event)">
              ></app-jkedit> -->
            <div class="border-1 border-blue-300">
              <input type="text" [(ngModel)]="element.value" />
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-tab>
  <mat-tab label="進階查詢">
    <mat-toolbar>
      <app-jkcombobox [items]="advParamList" [(value)]="advField"></app-jkcombobox>
      <app-jkcombobox [items]="compareList" [(value)]="advCompare">
      </app-jkcombobox>
      <div class="border-2 border-blue-300">
        <input type="text" [(ngModel)]="advValue" (input)="valueChange($event)" style="width: 160px;" />
      </div>
    </mat-toolbar>
    <mat-toolbar>
      <mat-radio-group aria-label="條件關係" [(ngModel)]="andOr" class="border-2 border-gray-400">
        <mat-radio-button value="AND">AND</mat-radio-button>
        <mat-radio-button value="OR">OR</mat-radio-button>
      </mat-radio-group>
      <mat-toolbar>
        <button (click)="doAdd()" class="btn-neutral">加入</button>
        <button (click)="doClear()" class="btn-neutral">清除</button>
      </mat-toolbar>
    </mat-toolbar>
    <div>
      <app-jktextarea class="w-full" [rows]="5" [(value)]="uiWhere"></app-jktextarea>
    </div>
  </mat-tab>
</mat-tab-group>
<!-- <app-jkedit [displayLabel]="false" [(value)]="advValue" (valueChange)="valueChange(advValue)">
  ></app-jkedit> -->
<div class="bottom-0 w-full ">
  <mat-toolbar class="bg-blue-300 border-solid">
    <button cdkFocusInitial (click)="doOk($event)" class="btn-primary">確定</button>
    <button (click)="doCancel($event)" class="btn-warning">取消</button>
  </mat-toolbar>
</div>
